export class TranslationStore {
    [key: string]: string | TranslationStore;
}

export class LocalStorageTranslations {
    language?: string;

    translations?: TranslationStore;
}
